import { useStyleSheet } from '../../../../../hooks/useStyleSheet';

export const useStyles = () => {
  const styles = useStyleSheet(
    () => ({
      root: {
        height: '100vh',
        position: 'relative',
      },
      img: {
        borderRadius: '10px',
        objectFit: 'fill',
        width: '100%',
      },
      button: {
        position: 'fixed',
        left: '50%',
        top: '55%',
      },
    }),
    [],
  );

  return styles;
};
